module.exports = __webpack_public_path__ + "img/feature_buy_bonus_cn.43425140.png";